import BasicModal from "../_widgets/Modal/BasicModal";
import { Row, Col } from "react-bootstrap";
import Input from "../_widgets/Input/Input";
import DatePickerWrapper from "../_widgets/Datepicker/DatePicker";
import MainLoader from "../_widgets/Loader/MainLoader";
import { warn } from "../../Wrapper/toast/toast";
import { MAX_AMT_LIMIT_REACHED, maximumLengthAllowed } from "../../Constants/stringConstants";
import { isNullOrEmpty } from "../../Utils/stringUtils";
import { changeDateFormatForDisplay } from "../../Utils/dateUtils";
import { getCreditStatus } from "../../Services/common";
import Dropdown from "../_widgets/Dropdown/Dropdown";

const EditCreditNote = ({
  modelShow,
  handleClose,
  handleSave,
  buttonLoading,
  creditNoteData,
  setCreditNoteData,
  loading,
}) => {
  return (
    <BasicModal
      show={modelShow}
      handleClose={handleClose}
      size="lg"
      footer
      heading="CN Settlement"
      button1Click={handleSave}
      loading={buttonLoading}
      button1Text="Save"
      minH="60vh"
    >
      {loading ? (
        <MainLoader />
      ) : (
        <Row>
          <Col lg={4}>
            <Input label="Medicine Name" value={creditNoteData?.product?.name} disabled />
          </Col>
          <Col lg={4}>
            <Input label="Bill Number" value={creditNoteData?.bill_no} disabled />
          </Col>
          <Col lg={4}>
            <Input
              inputType="currency"
              label="CN Amount"
              value={creditNoteData?.cn_amount}
              isRequired
              disabled
              allowDecimals={true}
              currencyPrefix={true}
              onValueChange={(val) => {
                if (val <= 99999 || isNullOrEmpty(val)) {
                  setCreditNoteData({ ...creditNoteData, cn_amount: val });
                } else {
                  warn(MAX_AMT_LIMIT_REACHED);
                }
              }}
            />
          </Col>
          <Col lg={4}>
            <Input
              label="CN Number"
              placeholder="Enter CN Number"
              disabled
              value={creditNoteData?.cn_number || ""}
              onChange={(e) =>
                e.target.value.length > 50
                  ? warn(maximumLengthAllowed(50))
                  : setCreditNoteData({
                      ...creditNoteData,
                      cn_number: e.target.value.slice(0, 50),
                    })
              }
            />
          </Col>
          <Col lg={4}>
            <Input
              label="Settled Bill Number"
              value={creditNoteData?.settled_bill_no}
              onChange={(e) => {
                setCreditNoteData({
                  ...creditNoteData,
                  settled_bill_no: e.target.value,
                });
              }}
            />
          </Col>
          <Col lg={4}>
            <DatePickerWrapper
              label="Return Date"
              isRequired
              disabled
              selected={changeDateFormatForDisplay(creditNoteData?.return_date)}
              value={changeDateFormatForDisplay(creditNoteData?.return_date)}
            />
          </Col>
          <Col lg={4}>
            <Dropdown
              label="Status"
              value={creditNoteData?.status}
              placeholder="Select Status"
              name={creditNoteData?.status}
              onChange={(selectedValue) =>
                setCreditNoteData({ ...creditNoteData, status: selectedValue })
              }
              options={getCreditStatus()}
            />
          </Col>
          <Col lg={4}>
            <Input
              label="Supplier Name"
              value={creditNoteData?.product_detail?.supplier?.name}
              disabled
            />
          </Col>

          <Col lg={12}>
            <Input
              label="Remarks (Optional)"
              placeholder="Enter Remarks Here"
              value={creditNoteData?.settled_remark || ""}
              onChange={(e) =>
                e.target.value.length > 100
                  ? warn(maximumLengthAllowed(100))
                  : setCreditNoteData({
                      ...creditNoteData,
                      settled_remark: e.target.value.slice(0, 100),
                    })
              }
            />
          </Col>
        </Row>
      )}
    </BasicModal>
  );
};

export default EditCreditNote;
